import React from "react";
import { ArrowDownIcon, ArrowRightIcon, CheckIcon, XIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { afterItems, beforeItems } from "../../data/content";
export function BeforeAfterSection() {
  return <section className="bg-mist px-5 py-16 sm:py-20" data-id="element-88" data-mp="3fe0qmby9xr61">
      <div className="mx-auto max-w-6xl" data-id="element-89" data-mp="3fesmlnvs9qwu">
        <SectionHeading kicker="The transformation" title="From Uncertain Whitening Decisions to a More Structured Clinical Approach" lead="Professional teeth whitening involves much more than applying a bleaching agent. Patient selection, discoloration type, treatment technique, sensitivity risk, and realistic expectations all influence clinical decisions." data-id="element-90" data-mp="6y79pw016dog" />

        <div className="mt-10 grid items-stretch gap-4 lg:grid-cols-[1fr_auto_1fr] lg:gap-6" data-id="element-91" data-mp="px34b8fswu2t">
          {/* BEFORE */}
          <div className="overflow-hidden rounded-3xl bg-white ring-2 ring-alert/25" data-id="element-92" data-mp="upczp3zoqmch">
            <div className="bg-alert px-5 py-4 text-white" data-id="element-93" data-mp="22nb94dfzjk8u">
              <p className="font-display text-[28px] font-black uppercase leading-none" data-id="element-94" data-mp="22lrpqdz18t2u">Before</p>
              <p className="mt-1.5 text-sm font-semibold text-white/90" data-id="element-95" data-mp="1xn6oqcbyi5dc">Without a structured clinical reference</p>
            </div>
            <ul className="divide-y divide-alert/10 px-5" data-id="element-96" data-mp="27mnt8qfh2d7q">
              {beforeItems.map(item => <li key={item} className="flex gap-3 py-4 text-[16px] leading-snug text-ink" data-id="element-97" data-mp="2ldsz4a9fo1qi">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-alert/10 text-alert" data-id="element-98" data-mp="2gg0y8qqt95a6">
                    <XIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-99" data-mp="2vc9s1crxmqf7" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="flex items-center justify-center" aria-hidden="true" data-id="element-100" data-mp="10zahvz6bmofb">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-navy-950 text-white" data-id="element-101" data-mp="w0pfpu7iduo8">
              <ArrowDownIcon className="h-6 w-6 lg:hidden" data-id="element-102" data-mp="1lp4m0hiinm8r" />
              <ArrowRightIcon className="hidden h-6 w-6 lg:block" data-id="element-103" data-mp="1pp54qecnejlm" />
            </span>
          </div>

          {/* AFTER */}
          <div className="overflow-hidden rounded-3xl bg-white ring-2 ring-cta/40" data-id="element-104" data-mp="1ungaacvwu7y1">
            <div className="bg-cta px-5 py-4 text-white" data-id="element-105" data-mp="1znulu4wq000t">
              <p className="font-display text-[28px] font-black uppercase leading-none" data-id="element-106" data-mp="1zl82l80gvw2r">After</p>
              <p className="mt-1.5 text-sm font-semibold text-white/95" data-id="element-107" data-mp="24kkxmg1hs9gf">With DENTAL BLEACHING BLUEPRINT™</p>
            </div>
            <ul className="divide-y divide-cta/10 px-5" data-id="element-108" data-mp="2df960f2d679g">
              {afterItems.map(item => <li key={item} className="flex gap-3 py-4 text-[16px] font-medium leading-snug text-ink" data-id="element-109" data-mp="2idsp87pkp4y4">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta text-white" data-id="element-110" data-mp="2ndousbdx54fs">
                    <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-111" data-mp="2sd1ieycm6fjf" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center font-display text-[22px] font-black leading-tight text-navy-950" data-id="element-112" data-mp="boidjr68n87n">
          Better Clinical Decisions Begin With Better Clinical Understanding.
        </p>
        <SectionCta label="Get my Dental Bleaching Blueprint™" note="Move from uncertainty to a clear clinical method today" data-id="element-113" data-mp="1tqjuyfs15i5" />
      </div>
    </section>;
}